var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"80vh"}},[_c('iframe',{ref:"sightmap",staticClass:"rentpress-engrain-sight-map",attrs:{"title":"rentpress engrain sight map","id":_vm.sightMapID,"src":_vm.engrainMapLink,"width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }